import { ReactElement } from 'react';
import { FormSpy } from 'react-final-form';
import { fmt } from 'utilities';
import { calculateTotals, InvoiceLike } from 'modules/invoicing/income/calculate';
import { Td, Tfoot, Th, Tr } from '@ff-it/ui';
import { sumCol } from 'styles/style.css';

function Totals({ preview = false }: { preview?: boolean }): ReactElement {
  const colSpan = preview ? 5 : 6;
  return (
    <FormSpy<InvoiceLike> subscription={{ values: true }}>
      {(formProps) => {
        const { totalInvoiced, vatRate, vatAmount, totalFinal } = calculateTotals(formProps.values);
        return (
          <Tfoot>
            <Tr>
              <Td colSpan={colSpan} textAlign="right" className={sumCol}>
                Sub-total
              </Td>
              <Td textAlign="right" data-testid="sub-total" className={sumCol}>
                {fmt(totalInvoiced)}
              </Td>
              <Td />
            </Tr>
            <Tr>
              <Td colSpan={colSpan} textAlign="right" className={sumCol}>
                VAT {vatRate}%
              </Td>
              <Td textAlign="right" data-testid="vat-amount" className={sumCol}>
                {fmt(vatAmount)}
              </Td>
              <Td />
            </Tr>
            <Tr>
              <Th colSpan={colSpan} textAlign="right" className={sumCol}>
                Total
              </Th>
              <Th textAlign="right" data-testid="total" className={sumCol}>
                {fmt(totalFinal)}
              </Th>
              <Td />
            </Tr>
          </Tfoot>
        );
      }}
    </FormSpy>
  );
}

export default Totals;
